import { IUser } from '@contexts/user-context';

export type LocalStorageKey =
    | 'LastActive'
    | 'ParentPageOrgKey'
    | 'PageNavIsCollapsed'
    | 'CentralMonitoringToolkit.OpenState'
    | 'IsLoggingOut'
    | 'LastLogoutReason'
    | 'SubjectMonitoringToolKit.OpenState'
    | 'ForceNavError'
    | 'RiskAssessmentToolKit.OpenState';

class LocalStorageService {
    localStorage: Storage;

    constructor(localStorage: Storage) {
        this.localStorage = localStorage;
    }

    setItem = (user: IUser, key: LocalStorageKey, value: string | boolean | null) => {
        this.localStorage.setItem(`${user.id}_${key}`, String(value));
    };

    getItem(user: IUser, key: LocalStorageKey): string | null {
        return this.localStorage.getItem(`${user.id}_${key}`);
    }

    removeItem(user: IUser, key: LocalStorageKey) {
        this.localStorage.removeItem(`${user.id}_${key}`);
    }

    clear(user: IUser) {
        for (let i = 0; i < this.localStorage.length; i++) {
            const key = this.localStorage.key(i);

            if (key?.startsWith(`${user.id}_`)) {
                this.localStorage.removeItem(key);
            }
        }
    }
}

// Currently, there's no good reason why we'd want localStorage to be shared between users, and as such eslint
// has been configured to error on other usages.
// eslint-disable-next-line no-restricted-globals
const LocalStorage = new LocalStorageService(localStorage);
export default LocalStorage;
